import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { allowedMessageProps, MessageArea } from '../../lists/SystemMessages';
import { allowedLanguages } from '../../../languages';
import { allowedInputTypes } from './_allowedPropTypes';

const InputContainer = ({
  language,
  inputAttributes,
  children,
  message,
  label,
  isSwappedAlign,
  wrapperClasses = []
}) => {
  const {
    type,
    required,
    isEnhanced
  } = inputAttributes;

  const inputWrapClasses = [...wrapperClasses, 'input-wrap'];

  if (type === 'checkbox' || type === 'radio') {
    inputWrapClasses.push(`style-${type}`);
  }

  if (required) {
    inputWrapClasses.push('input-required');
  }

  if (isSwappedAlign) {
    inputWrapClasses.push('swapped-align');
  }

  if (isEnhanced) {
    inputWrapClasses.push('enhanced-input-wrap');
  }

  const inputWrapAttributes = { className: inputWrapClasses.join(' ') };

  const inputWrapContent = (
    <React.Fragment key='input'>
      {children}
      <MessageArea language={language} message={message} />
    </React.Fragment>
  );

  if (label) {
    const labelElement = <span key='label'>{label}</span>;
    const arrangement = (type === 'checkbox' || type === 'radio' || isSwappedAlign)
      ? [inputWrapContent, labelElement]
      : [labelElement, inputWrapContent];

    return (
      <label {...inputWrapAttributes}>
        {arrangement}
      </label>
    );
  }

  return (
    <div {...inputWrapAttributes}>
      {inputWrapContent}
    </div>
  );
};

InputContainer.propTypes = {
  language: PropTypes.oneOf(allowedLanguages).isRequired,
  inputAttributes: PropTypes.shape({ type: PropTypes.oneOf(allowedInputTypes) }),
  message: PropTypes.shape(allowedMessageProps),
  isEnhanced: PropTypes.bool,
  wrapperClasses: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ])
};

export default connect(({ language }) => ({ language }))(InputContainer);